import { render } from "./VerticalCenterModal.vue?vue&type=template&id=655a5826"
import script from "./VerticalCenterModal.vue?vue&type=script&lang=js"
export * from "./VerticalCenterModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__